import {RootState} from "./store";

export const loadState = () => {
  try {
    const serializedState = localStorage.getItem("galactic-state");
    if (serializedState === null) {
      return undefined;
    }
    return { Authentication: JSON.parse(serializedState) };
  } catch (err) {
    return undefined;
  }
};

export const saveState = (state: RootState) => {
  try {
    const serializedState = JSON.stringify(state.Authentication);
    localStorage.setItem("galactic-state", serializedState);
  } catch (err) {
    // ignored
  }
};
